module.exports = __webpack_public_path__ + "static/media/img_bg1.0c3e5eaa.jpg";